import React from 'react';
import AutoComplete from 'antd/lib/auto-complete';
import 'antd/lib/auto-complete/style/css';
// APOLLO
import customDashboardsQuery from 'ApolloClient/Queries/customDashboards';
import { Query } from 'react-apollo';

const Option = AutoComplete.Option;

class DashboardsInput extends React.Component {
  state = {
    searchText: (this.props.value && this.props.value.label) || null,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.props.value) {
      this.setState({
        searchText: (newProps.value && newProps.value.label) || null,
      });
    }
  }

  getOptions = dashboards => dashboards.map(dashboard => (
    <Option key={dashboard._id} value={dashboard._id}>
      <img src={dashboard.icon} height="75" /> {dashboard.name}
    </Option>
  ));

  handleOnSearch = searchText => {
    this.setState({
      searchText,
    });
  };

  handleOnSelect = selection => {
    let selectedDashboard = this.state.dashboards.filter(dashboard => dashboard._id === selection);
    this.props.onChange(selectedDashboard[0]);
  };

  render() {
    return (
      <Query
        query={customDashboardsQuery}
        onCompleted={data => this.setState({ dashboards: data.customDashboards })}
        variables={{
          params: {
            searchText: this.state.searchText,
          },
        }}
      >
        {({ loading, data }) => {
          console.log(data);
          return (
            <AutoComplete
              dataSource={!loading && this.state.dashboards ? this.getOptions(this.state.dashboards) : []}
              style={this.props.style}
              size={this.props.size}
              onSelect={this.handleOnSelect}
              onSearch={this.handleOnSearch}
              placeholder="search dashboards...."
              value={this.state.searchText}
            />
          );
        }}
      </Query>
    );
  }
}

DashboardsInput.defaultProps = {
  size: 'large',
  style: {
    width: '100%',
    minWidth: '120px',
    maxWith: '100%',
  },
};

export default DashboardsInput;



// WEBPACK FOOTER //
// ./src/components/inputs/DashboardsInput/index.js